import { useState, useCallback } from "react";
import { updates } from "@/shared/components/Updates/loadUpdates";

const STORAGE_KEY = "hourglass_last_seen_update";

export function useUpdateNotification() {
	const latestSlug = updates[0]?.slug ?? "";
	const [hasNewUpdate, setHasNewUpdate] = useState(
		() => latestSlug !== "" && localStorage.getItem(STORAGE_KEY) !== latestSlug,
	);

	const dismissUpdate = useCallback(() => {
		if (latestSlug) {
			localStorage.setItem(STORAGE_KEY, latestSlug);
			setHasNewUpdate(false);
		}
	}, [latestSlug]);

	return { hasNewUpdate, dismissUpdate };
}
